import getInitialProps from 'widget/LiveProfile/helpers/getInitialProps';
import getProperStream from 'widget/LiveProfile/helpers/getProperStream';

export default { getInitialProps, getProperStream };
